module.exports = __webpack_public_path__ + "e546a8f5.svg";